function addMessageDefaultData (msg) {
    if (!msg) return false
    if (!('cidType' in msg)) msg.cidType = declarations.chatTargetTypes.CHAT_TARGET_TYPE_USER
    try {
        if (msg.dataType && (msg.dataType === 'data' || msg.dataType === 'unstored')) {
            msg.data = JSON.parse(msg.data)
        }
        return true
    } catch (e) {
        // this.log('addMessageDefaultData: < error: invalid data: ' + msg.data)
        return false
    }
}

export default {
    emitters: {
        /**
         * @param params {Object}
         * @param [params.cidType='user'] {String}
         * @param params.cid {Number}
         * @param [params.dataType='text']
         * @param [params.data] {String}
         * @param [params.dataFile] {String}
         * @param cb
         */
        sendMessage(params, cb) {
            // var data = { cidType: params.cidType, cid: params.cid, dataType: params.dataType, data:  params.data, dataFile: params.dataFile, replyId: params.replyId }; //@todo здесь в строку преоброзововать
            this.log('sendMessage: > ' + JSON.stringify(params))
            this.socket.emit('send-message', params, (data) => {
                this.log('sendMessage: < ' + JSON.stringify(data))
                return cb && cb(data)
            })
        },
        sendMessageAsync(params) {
            return new Promise((resolve, reject) => this.sendMessage(params, resolve))
        },
        sendMessageAsyncWithTimeout(params) {
            let data
            return new Promise(async (resolve, reject) => {
                try {
                    const timeout = 10000
                    data = await this._emitWithTimeOut('send-message', params, timeout)
                } catch (e) {
                    this.log('send-message: < error: ' + e.message)
                    reject(e)
                }
                resolve(data)
            })
        },
        /**
         * @param cidType {String}
         * @param cid {Number}
         */
        sendTypingEvent(cidType, cid) {
            let dataType = 'unstored'
            let data = { cidType, cid, dataType, data: JSON.stringify({ 'type': 'message-writing' }) }
            this.log('sendTyping: > ' + JSON.stringify(data))
            this.socket.emit('send-message', data, (data) => {
                this.log('sendTyping: < ' + JSON.stringify(data))
            })
        },
        editMessage(payload) {
            return new Promise((resolve, reject) => {
                this.log('editMessage: > ' + JSON.stringify(payload))
                this.socket.emit('edit-message', payload, (data) => {
                    let {rev, error} = data || {}
                    if (error) {
                        this.log('editMessage: < edit-message error: ' + error)
                        return reject(new Error(error))
                    }
                    this.log('edit-message: < rev: ' + rev)
                    resolve(rev)
                })
            })
        },
        getMessages(params) {
            return new Promise((resolve, reject) => {
                let data = {
                    cidType: params.cidType,
                    cid: params.cid,
                    startId: params.startId,
                    count: params.count,
                    scrollDown: params.scrollDown,
                    commentId: params.commentId,
                }
                this.log('getMessages: > ' + JSON.stringify(data))
                this.socket.emit('get-messages', data, (data) => {
                    this.log('getMessages: < ' + data.length)
                    if (data && data.forEach) {
                        data.forEach((cur, index) => {
                            if (!addMessageDefaultData(cur)) delete data[index]
                        })
                    }
                    resolve(data)
                })
            })
        },
        getMessagesMedia(params) {
            return new Promise((resolve, reject) => {
                let data = {
                    cidType: params.cidType,
                    cid: params.cid,
                    type: params.type,
                    filter: params.filter,
                    startId: params.startId,
                    count: params.count
                }
                this.log('getMessagesMedia: > ' + JSON.stringify(data))
                this.socket.emit('get-messages-media', data, (data) => {
                    this.log('getMessagesMedia: < ' + data.length)
                    try {
                        data.forEach((cur, index) => {
                            if (!addMessageDefaultData(cur)) delete data[index]
                        })
                        resolve(data)
                    } catch (error) {
                        console.log("🚀 ~ messages.js:117 ~ getMessagesMedia ~ error:", error)
                    }
                })
            })
        },
        getMessage(params) {
            return new Promise((resolve, reject) => {
                let data = {cidType: params.cidType, cid: params.cid, id: params.id}
                this.log('getMessage: > ' + JSON.stringify(params))
                this.socket.emit('get-message', data, (data) => {
                    this.log('getMessage: < ' + JSON.stringify(data))
                    if (!addMessageDefaultData(data)) data = null
                    resolve(data)
                })
            })
        },
        getMessageDetails(params, cb) {
            let data = { cidType: 'group', cid: params.cid, id: params.id }
            this.log('getMessageDetails: > ' + JSON.stringify(data))
            data && this.socket.emit('get-message-details', data, (data) => {
                this.log('getMessageDetails: < ' + data.length)
                return cb && cb(data)
            })
        },
        setMessageReceived(id) {
            return new Promise((resolve, reject) => {
                const data = {id}
                this.log('setMessageReceived: > ' + JSON.stringify(data))
                this.socket.emit('set-message-received', data, (data) => {
                    if (!data || !data.rev) {
                        this.log('setMessageReceived: < set-message-received error: ' + JSON.stringify(data))
                        return reject()
                    }
                    this.log('setMessageReceived: < ' + JSON.stringify(data))
                    resolve(data.rev)
                })
            })
        },
        setMessageWatched(id, cb) {
            let data = { id: id }
            this.log('setMessageWatched: > ' + JSON.stringify(data))
            this.socket.emit('set-message-watched', data, (data) => {
                this.log('setMessageWatched: < ' + JSON.stringify(data))
                return cb && cb(data)
            })
        },
        setMessageWatchedAsync(id) {
            return new Promise((resolve, reject) => {
                let data = {id}
                this.log('setMessageWatched async: > ' + JSON.stringify(data))
                this.socket.emit('set-message-watched', data, (data) => {
                    this.log('setMessageWatched async: < ' + JSON.stringify(data))
                    resolve(data)
                })
            })
        },
        setMessageDeleted(id, everyone) {
            return new Promise((resolve, reject) => {
                let data = {id: id}
                if (everyone) data.everyone = everyone
                this.log('setMessageDeleted: > ' + JSON.stringify(data))
                this.socket.emit('set-message-deleted', data, (data) => {
                    this.log('setMessageDeleted: < ' + JSON.stringify(data))
                    resolve(data)
                })
            })
        },
        setMessageReaction(id, reaction) {
            return new Promise((resolve, reject) => {
                const data = {id, reaction}
                // this.log('setMessageReaction: > ' + JSON.stringify(data))
                console.log('setMessageReaction: > ' + JSON.stringify(data))
                this.socket.emit('set-message-reaction', data, (data) => {
                    // this.log('setMessageReaction: < ' + JSON.stringify(data))
                    console.log('setMessageReaction: < ' + JSON.stringify(data))
                    resolve(data)
                })
            })
        },
        // getUnwatchedMessages(msgIds, cb) {
        //     let data = msgIds
        //     this.log('getUnwatchedMessages: > ' + JSON.stringify(data))
        //     this.socket.emit('get-unwatched-messages', data, (data) => {
        //         this.log('getUnwatchedMessages:  < ' + JSON.stringify(data))
        //         data.forEach((cur) => { addMessageDefaultData(cur) })
        //         cb && cb(data)
        //     })
        // },
        getUnwatchedMessagesAsync(msgIds) {
            return new Promise((resolve, reject) => {
                let data = msgIds
                this.log('getUnwatchedMessagesAsync: > ' + JSON.stringify(data))
                this.socket.emit('get-unwatched-messages', data, (data) => {
                    this.log('getUnwatchedMessagesAsync:  < ' + JSON.stringify(data))
                    data.forEach((cur) => addMessageDefaultData(cur))
                    resolve(data)
                })
            })
        },
        setMessageCommentSubscribed(params) {
            return new Promise((resolve, reject) => {
                this.log('set-message-comment-subscribed: > ' + JSON.stringify(params))
                const out_data = { id: params.id, status: params.status || false }
                this.socket.emit('set-message-comment-subscribed', out_data, (data) => {
                    this.log('set-message-comment-subscribed: < ' + JSON.stringify(data))
                    resolve(data)
                })
            })
        },
        searchGlobalData(params) {
            return new Promise((resolve, reject) => {
                const { type, filter = 'messages', fromId = 0, count = 0, mediaType } = params
                const payload = {type, filter, fromId, count, mediaType}
                this.log('search-global-data: > ' + JSON.stringify(params))
                this.socket.emit('search-global-data', payload, (data) => {
                    this.log('searchGlobalData: < ' + JSON.stringify(data))
                    if (!addMessageDefaultData(data)) data = null
                    resolve(data)
                })
            })
        },
        searchMessages(params) {
            return new Promise((resolve, reject) => {
                let data = {
                    cidType: params.cidType,
                    cid: params.cid,
                    type: params.type,
                    filter: params.filter,
                    startId: params.startId,
                    count: params.count
                }
                if (params && params.commentId) data.commentId = params.commentId
                this.log('searchMessages: > ' + JSON.stringify(data))
                this.socket.emit('search-messages', data, (data) => {
                    this.log('searchMessages: < ' + data.length)
                    data.forEach((cur, index) => {
                        if (!addMessageDefaultData(cur)) delete data[index]
                    })
                    resolve(data)
                })
            })
        },        
    },
    listeners: {
        'message-event'(data) {
            this.log('bind: < message-event: ' + JSON.stringify(data))
            if (addMessageDefaultData(data)) this.emit('message-event', data)
        },
        'message-change-event'(data) {
            this.log('bind: < message-change-event: ' + JSON.stringify(data))
            this.emit('message-change-event', data)
        },
        'message-update-event'(data) {
            this.log('bind: < message-update-event: ' + JSON.stringify(data))
            if (addMessageDefaultData(data)) this.emit('message-update-event', data)
        },
        'message-reaction-event'(data) {
            this.log('bind: < message-reaction-event: ' + JSON.stringify(data))
            if (addMessageDefaultData(data)) this.emit('message-reaction-event', data)
        },
        'message-comment-subscribed-event'(data) {
            this.log('bind: < message-comment-subscribed-event: ' + JSON.stringify(data))
            if (addMessageDefaultData(data)) this.emit('message-comment-subscribed-event', data)
        },
        'message-comment-event'(data) {
            this.log('bind: < message-comment-event: ' + JSON.stringify(data))
            if (addMessageDefaultData(data)) this.emit('message-comment-event', data)
        },
        'message-comment-reaction-event'(data) {
            this.log('bind: < message-comment-reaction-event: ' + JSON.stringify(data))
            if (addMessageDefaultData(data)) this.emit('message-comment-reaction-event', data)
        },
        'message-comment-update-event'(data) {
            this.log('bind: < message-comment-update-event: ' + JSON.stringify(data))
            if (addMessageDefaultData(data)) this.emit('message-comment-update-event', data)
        },
        'message-comment-change-event'(data) {
            this.log('bind: < message-comment-change-event: ' + JSON.stringify(data))
            this.emit('message-comment-change-event', data)
        },
    },
}